import { render } from "./OptionsValues.vue?vue&type=template&id=bff4b338&scoped=true&ts=true"
import script from "./OptionsValues.vue?vue&type=script&lang=ts"
export * from "./OptionsValues.vue?vue&type=script&lang=ts"

import "./OptionsValues.vue?vue&type=style&index=0&id=bff4b338&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff4b338"]])

export default __exports__